const { buildErrResponse } = require("../_utils/utils");
const { BASE_URL, BASE_URL_DEV } = require("../_constants/urlConstants");
const { default: Axios } = require("axios");

export const SellService = {
  getAllSells,
  getAllSellsWithParams,
  getSellByProductId,
  updateSell,
  createSell,
  createBulkSell,
};

function getAllSells(body) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/sell`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllSellsWithParams(queryParams) {
  const { productTypeId, siteId, userId, clientId, startDate, endDate } =
    queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/sell`, {
      params: {
        productTypeId,
        siteId,
        userId,
        clientId,
        startDate,
        endDate,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function getSellByProductId(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/sell/by-productId?id=${id}`, {})
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateSell(body, id) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/sell?id=${id}`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function createSell(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/sell`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function createBulkSell(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/sell/bulk`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(err.response);
      });
  });
}
